import React from 'react'
import { QcType } from '../../constants'
import './style.less'
import scenarioTagImg from '../../../../../assets/images/scenario-tag.png'
import mocImg from '../../../../../assets/images/moc.png'
import complianceImg from '../../../../../assets/images/compliance.png'
const ChooseScheme = ({ onChange }: { onChange: (type: number) => void }) => {
  return (
    <div className="choose-scheme">
      <div className="choose-scheme-item" onClick={() => onChange(QcType.compliance)}>
        <div className="choose-scheme-item-content">
          <h2>我想要了解坐席是否违规--做出判断</h2>
          <div className="choose-scheme-item-description">
            <span>规则用途：</span>
            <p>设立规则，并判断通话中的行为是否违反规则</p>
          </div>
          <div className="choose-scheme-item-description">
            <span>质检形式：</span>
            <p>设置违规规则，详述违规和合规情形，由大模型根据规则判断通话行为是否违规，以及违反哪一项规则</p>
          </div>
        </div>
        <img src={complianceImg} alt="" />
      </div>
      <div className="choose-scheme-item" onClick={() => onChange(QcType.moc)}>
        <div className="choose-scheme-item-content">
          <h2>我想要评估坐席销售能力--给出评分</h2>
          <div className="choose-scheme-item-description">
            <span>规则用途：</span>
            <p>我想要评估坐席销售能力--给出评分</p>
          </div>
          <div className="choose-scheme-item-description">
            <span>质检形式：</span>
            <p>设置评分项，并为其赋分，由大模型根据规则为每一个质检项打分</p>
          </div>
        </div>
        <img src={mocImg} alt="" />
      </div>
      <div className="choose-scheme-item" onClick={() => onChange(QcType.scenarioTag)}>
        <div className="choose-scheme-item-content">
          <h2>我想要了解客户/坐席情绪等通话情景--贴上标签</h2>
          <div className="choose-scheme-item-description">
            <span>规则用途：</span>
            <p>评估客户/坐席在通话中表现出来的情绪等场景</p>
          </div>
          <div className="choose-scheme-item-description">
            <span>质检形式：</span>
            <p>设置情绪分类，并描述情绪场景，由大模型判断通话双方的情绪</p>
          </div>
        </div>
        <img src={scenarioTagImg} alt="" />
      </div>
    </div>
  )
}

export default ChooseScheme
